import global from '../config/global'
import md5 from 'js-md5'
import EventBusConstant from "../push/const/EventBusConstant";
import {doLoginAsVisitor} from "../api/home-api";
import IMManager from "../im/IMManager";
import TipsUtils from "./TipsUtils";
import accountApi from '../api/account-api'
import AppSDK from "../api/aapp";
export const ToastType = {
  TOAST_INFO: 1,
  TOAST_DEBUG: 2,
  TOAST_WARN: 3,
  TOAST_ERROR: 4,
}
export const ToastTime = {
  SHORT: 2 * 1000,
  LONG: 5 * 1000,
}
export const Toast = {
  info: (msg, vueObj, showTime = ToastTime.SHORT) => vueObj.$EventBus.$emit(global.TOAST, msg, ToastType.TOAST_INFO, showTime),
  notice: (msg, vueObj, showTime = ToastTime.SHORT) => vueObj.$EventBus.$emit(global.TOAST, msg, ToastType.TOAST_DEBUG, showTime),
  warn: (msg, vueObj, showTime = ToastTime.SHORT) => vueObj.$EventBus.$emit(global.TOAST, msg, ToastType.TOAST_WARN, showTime),
  error: (msg, vueObj, showTime = ToastTime.SHORT) => vueObj.$EventBus.$emit(global.TOAST, msg, ToastType.TOAST_ERROR, showTime)

}

export const showDeviceError = function (vueObj) {
  vueObj.$EventBus.$emit(global.SHOW_DEVICE_ERROR)
}

/**
 * Created by hdwang on 2019/1/28.
 */
var convertUtf8 = (function () {

  /**
   * unicode string to utf-8
   * @param text 字符串
   * @returns {*} utf-8编码
   */
  function toBytes(text) {
    var result = [], i = 0;
    text = encodeURI(text);
    while (i < text.length) {
      var c = text.charCodeAt(i++);

      // if it is a % sign, encode the following 2 bytes as a hex value
      if (c === 37) {
        result.push(parseInt(text.substr(i, 2), 16))
        i += 2;

        // otherwise, just the actual byte
      } else {
        result.push(c)
      }
    }

    return coerceArray(result);
  }


  /**
   * utf8 byte to unicode string
   * @param utf8Bytes
   * @returns {string}
   */
  function utf8ByteToUnicodeStr(utf8Bytes) {
    var unicodeStr = "";
    for (var pos = 0; pos < utf8Bytes.length;) {
      var flag = utf8Bytes[pos];
      var unicode = 0;
      if ((flag >>> 7) === 0) {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;

      } else if ((flag & 0xFC) === 0xFC) {
        unicode = (utf8Bytes[pos] & 0x3) << 30;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 24;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 18;
        unicode |= (utf8Bytes[pos + 3] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 4] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 5] & 0x3F);
        unicodeStr += String.fromCodePoint(unicode);
        pos += 6;

      } else if ((flag & 0xF8) === 0xF8) {
        unicode = (utf8Bytes[pos] & 0x7) << 24;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 18;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 3] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 4] & 0x3F);
        unicodeStr += String.fromCodePoint(unicode);
        pos += 5;

      } else if ((flag & 0xF0) === 0xF0) {
        unicode = (utf8Bytes[pos] & 0xF) << 18;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 12;
        unicode |= (utf8Bytes[pos + 2] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 3] & 0x3F);
        unicodeStr += String.fromCodePoint(unicode);
        pos += 4;

      } else if ((flag & 0xE0) === 0xE0) {
        unicode = (utf8Bytes[pos] & 0x1F) << 12;
        ;
        unicode |= (utf8Bytes[pos + 1] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 2] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 3;

      } else if ((flag & 0xC0) === 0xC0) { //110
        unicode = (utf8Bytes[pos] & 0x3F) << 6;
        unicode |= (utf8Bytes[pos + 1] & 0x3F);
        unicodeStr += String.fromCharCode(unicode);
        pos += 2;

      } else {
        unicodeStr += String.fromCharCode(utf8Bytes[pos]);
        pos += 1;
      }
    }
    return unicodeStr;
  }


  function checkInt(value) {
    return (parseInt(value) === value);
  }

  function checkInts(arrayish) {
    if (!checkInt(arrayish.length)) {
      return false;
    }

    for (var i = 0; i < arrayish.length; i++) {
      if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
        return false;
      }
    }

    return true;
  }

  function coerceArray(arg, copy) {

    // ArrayBuffer view
    if (arg.buffer && arg.name === 'Uint8Array') {

      if (copy) {
        if (arg.slice) {
          arg = arg.slice();
        } else {
          arg = Array.prototype.slice.call(arg);
        }
      }

      return arg;
    }

    // It's an array; check it is a valid representation of a byte
    if (Array.isArray(arg)) {
      if (!checkInts(arg)) {
        throw new Error('Array contains invalid value: ' + arg);
      }

      return new Uint8Array(arg);
    }

    // Something else, but behaves like an array (maybe a Buffer? Arguments?)
    if (checkInt(arg.length) && checkInts(arg)) {
      return new Uint8Array(arg);
    }

    throw new Error('unsupported array-like object');
  }

  return {
    toBytes: toBytes,
    fromBytes: utf8ByteToUnicodeStr
  }
})()

export function isnull(src) {
  return src == null || src === '' || src === 'null' || src.length === 0 || typeof src === 'undefined' || (typeof src === 'object' && Object.keys(src).length == 0)
}

export function isNum(val) {
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，

  if (val === '' || val == null) {
    return false
  }
  if (!isNaN(val)) {
    //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
    //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
    return true
  } else {
    return false
  }
}

export function isLegalEmail(email) {
  if (isnull(email)) {
    return false
  }
  if ((email.length > 128) || (email.length < 6)) {
    return false
  }
  var format = /^[A-Za-z0-9+]+[A-Za-z0-9\\.\\_\-+]*@([A-Za-z0-9\-]+\.)+[A-Za-z0-9]{2,6}$/
  // var format=/[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z0-9]{2,6}$/
  if (!email.match(format)) {
    return false
  }
  return true
}

export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export function validatePWD(pwd) {
  if (isnull(pwd)) {
    return false
  }
  /**
   * //密码强度正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
   var pPattern = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
   * @type {RegExp}
   */
  let format = /^[a-zA-Z0-9_!@#$%^&*?]+$/

  return pwd.match(format)
}

export function reLogin(vueObj, successCallback = null, failCallback = null,) {
  if (!isnull(vueObj)) {
    vueObj.$EventBus.$emit(global.RE_LOGIN, successCallback, failCallback)
  }
}

export function showDialog(vueObj, msg = null) {
  if (!isnull(vueObj)) {
    vueObj.$EventBus.$emit(global.LOADING_SHOW, msg)
  }
}

export function hideDialog(vueObj) {
  if (!isnull(vueObj)) {
    vueObj.$EventBus.$emit(global.LOADING_HIDE)
  }
}

export function wrapVal(srcVal, defaultVal = '') {
  if (!isnull(srcVal)) {
    return srcVal
  }
  return isnull(defaultVal) ? '' : defaultVal
}

export function getVal(srcObj, key, defaultVal = '') {
  if (isnull(srcObj) || isnull(srcObj[key])) {
    return defaultVal
  }
  return srcObj[key]
}

export function getBooleanVal(src) {
  if (src === 'true') {
    return true
  }
  if (src === 'false') {
    return false
  }
  return src
}

export function localSave(key, val) {
  localStorage.setItem(key, val)
}

export function localGet(key, defaultVal = null) {
  let val = localStorage.getItem(key)
  if (!val) {
    val = defaultVal
  }
  return val
}

export function localGetBoolean(key, defaultVal = null) {
  let val = localStorage.getItem(key)
  if (!val) {
    val = defaultVal
  }
  return typeof val == 'string' ? val == 'true' : val
}

export function localRemove(key) {
  localStorage.removeItem(key)
}

export function localClear() {
  if (isnull(global.exceptKeys))
    localStorage.clear()
  else
    localClearExcept(global.exceptKeys)
}

function findLikesInArray(array, target) {
  if (isnull(array) || isnull(target))
    return -1;
  for (let i = 0; i < array.length; i++) {
    let tmp = array[i];
    if (tmp.indexOf(target) > -1)
      return i;
  }
  return -1;
}

function localClearExcept(exceptKeys) {
  let keys = []
  for (let i = 0; i < localStorage.length; i++) {
    keys.push(localStorage.key(i))
  }
  for (let i = 0; i < exceptKeys.length; i++) {
    let exceptKey = exceptKeys[i];
    let number = -1;
    do {
      number = exceptKey.fullCompare ? keys.indexOf(exceptKey.key) : findLikesInArray(keys, exceptKey.key);
      if (number != -1) {
        keys.splice(number, 1)
      }
    } while (number != -1)
  }
  for (let i = 0; i < keys.length; i++) {
    localStorage.removeItem(keys[i])
  }
}

export function sessionSave(key, val) {
  sessionStorage.setItem(key, val)
}

export function sessionGet(key, defaultVal) {
  let val = sessionStorage.getItem(key)
  if (!val) {
    val = defaultVal
  }
  return val
}

export function sessionRemove(key) {
  sessionStorage.removeItem(key)
}

export function sessionClear() {
  sessionStorage.clear()
}

export function importJS(src) {
  let new_element = document.createElement('script')
  new_element.setAttribute('type', 'text/javascript')
  new_element.setAttribute('src', src)
  document.getElementsByTagName('head')[0].appendChild(new_element)

}

export function Uint8ArrayToString(array) {
  return convertUtf8.fromBytes(array)

}

export function stringToUint8Array(string) {
  return convertUtf8.toBytes(string)
}

export function validator(formData, fields) {
  const keys = Object.keys(formData)
  for (const key of keys) {
    if (fields.indexOf(key) !== -1) {
      if (!formData[key]) {
        Toast.error('Please Enter ' + key)
        return false
      }
    }
  }
  return true
}

export function serializeFormData(domId) {
  const formData = $('#' + domId).serializeArray()
  const obj = {}
  for (var item of formData) {
    var key = item.name
    var val = item.value
    obj[key] = val
  }
  console.log('form data', obj)
  return obj
}

// export function makeBlobByFetch (src) {
//   return fetch(src).then(res => {
//     const blob = res.blob()
//     return blob
//   })
// }

export function canvasToDataURL(canvas, format, quality) {
  return canvas.toDataURL(format || 'image/jpeg', quality || 1.0)
}

export function dataURLToBlob(dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {type: mime})
}

export function imageToCanvas(src, cb) {
  var canvas = document.createElement('CANVAS')
  var ctx = canvas.getContext('2d')
  var img = new Image()
  img.src = src
  img.onload = function () {
    canvas.width = img.width
    canvas.height = img.height
    ctx.drawImage(img, 0, 0)
    cb(canvas)
  }
}

export function fileOrBlobToDataURL(obj, cb) {
  var a = new FileReader()
  a.readAsDataURL(obj)
  a.onload = function (e) {
    cb(e.target.result)
  }
}

//Blob 转 image
export function blobToImage(blob, cb) {
  fileOrBlobToDataURL(blob, function (dataurl) {
    var img = new Image()
    img.src = dataurl
    cb(img)
  })
}

//image 转 Blob
export function imageToBlob(src, cb) {
  imageToCanvas(src, function (canvas) {
    cb(dataURLToBlob(canvasToDataURL(canvas)))
  })
}

export function getDaysOffsetDayFrom2017(curTime) {
  let lastDay = new Date(2017, 0, 1, 0, 0, 0).getTime() + parseInt(curTime) * 1000
  let curDay = new Date().getTime()
  // let targetTimezone = -8
  // let _dif = new Date().getTimezoneOffset()
  // let date = new Date(new Date(curTime).getTime() + _dif * 60 * 1000 - (targetTimezone * 60 * 60 * 1000))
  // let lastDay = new Date(2017, 0, 1, 0, 0, 0);
  let usedTime = Math.abs(lastDay - curDay)  //两个时间戳相差的毫秒数
  let days = Math.floor(usedTime / (24 * 3600 * 1000))
  return days

}

function dateDiff(faultDate, completeTime) {
  let stime = new Date(faultDate).getTime()
  let etime = new Date(completeTime).getTime()
  let usedTime = etime - stime  //两个时间戳相差的毫秒数
  let days = Math.floor(usedTime / (24 * 3600 * 1000))
  //计算出小时数
  let leave1 = usedTime % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000)        //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))
  let leave3 = leave2 % (60 * 1000)//计算分钟数后剩余的毫秒数
  let second = Math.floor(leave3 / 1000)
  // var time = days + "天"+hours+"时"+minutes+"分";
  let time = (days * 24 + hours) + 'h' + minutes + 'm' + second + 's'
  // 600 days, 3:59:12
  if (days < 0 || hours < 0 || minutes < 0 || second < 0) {
    time = '0h0m0s'
  }
  return time;
}

export function getURLBase64(url) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (this.status === 200) {
        var blob = this.response
        var fileReader = new FileReader()
        fileReader.onloadend = function (e) {
          var result = e.target.result
          resolve(result)
        }
        fileReader.readAsDataURL(blob)
      }
    }
    xhr.onerror = function () {
      reject()
    }
    xhr.send()
  })
}

function getImageBlob(url, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open("get", url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    if (this.status == 200) {
      if (cb) cb(this.response);
    }
  };
  xhr.send();
}

export function preView(url, defaultimg) {
  let reader = new FileReader();

  getImageBlob(url, function (blob) {
    reader.readAsDataURL(blob);
  });

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {

      new Promise((resolve, reject) => {
        let img = new Image() // 等价于 document.createElement("img");
        img.crossOrigin = 'anonymous' // 设置可以请求跨域图片
        img.src = e.target.result
        img.onload = () => resolve(img)
        // 事件在图片加载完成后立即执行。
        img.onerror = () => /*reject(new Error("图片加载失败"))*/img.src = defaultimg

      }).then(promise => {
        return promise
      })

    }
  })

}

export function getCurSecTimestamp() {
  return Math.floor(Date.now() / 1000)
}

export function getZoneTime(offset, format) {
  // 取本地时间
  var localtime = new Date();
  // 取本地毫秒数
  var localmesc = localtime.getTime();
  // 取本地时区与格林尼治所在时区的偏差毫秒数
  var localOffset = localtime.getTimezoneOffset() * 60000;
  // 反推得到格林尼治时间
  var utc = localOffset + localmesc;
  // 得到指定时区时间
  var calctime = utc + (3600000 * offset);
  var nd = new Date(calctime);
  if (isnull(format))
    return nd;
  return nd.Format(format);
}

export function warpValue(format, length, type, src) {
  if (isnull(src))
    return src
  if (src.toString().length < length) {
    let prex = '';
    let size = length - src.toString().length
    if (size > 0)
      for (let i = 0; i < size; i++) {
        prex += format
      }
    if (type == 1)
      src = prex + src;
    else
      src = src + prex
    return src
  }
}

Date.prototype.Format = function (fmt) { //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

/*
对Date的扩展，将 Date 转化为指定格式的String
月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q)可以用1-2个占位符
年(y)可以用1-4个占位符，毫秒(S)只能用1个占位符号(是1-3为的数字)
例子：
(new Date()).Format("yyyy-MM-dd hh:mm:ss.S")	==> 2006-07-02 08:09:04.423
(new Date()).Format("yyyy-M-d h:m:s.S")			==> 2006-7-2 8:9:4.18
*/
Date.prototype.format = function (fmt) {
  const o = {
    "y+": this.getFullYear(),
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "H+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "S+": this.getMilliseconds(),
    "q+": Math.floor(this.getMonth() / 3) + 1,
    "h+": (() => {
      const hour = this.getHours() % 12;
      return hour == 0 ? 12 : hour;
    })(),
    "E+": (() => {
      const week = {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      };
      return week[this.getDay() + ""];
    })(),
    /*
    "e+": (()=>{
      const week = {"0":"Sun","1":"Mon","2":"Tue","3":"Wed","4":"Thu","5":"Fri","6":"Sat"};
      return week[this.getDay()+""];
    })(),
    */
    "x1": (() => {
      const week = {"0": "周日", "1": "周一", "2": "周二", "3": "周三", "4": "周四", "5": "周五", "6": "周六"};
      return week[this.getDay() + ""];
    })(),
    "x2": (() => {
      const hour = ["凌晨", "早上", "下午", "晚上"];
      const h = this.getHours();
      if (h == 12) return "中午";
      return hour[parseInt(h / 6)];
    })(),
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")", "g").test(fmt)) {
      const len = RegExp.$1.length;
      fmt = fmt.replace(RegExp.$1, len == 1 ? o[k] : ("00" + o[k]).substr(-len));
    }
  }
  return fmt;
}
Date.prototype.withFormat = function (format, real = true) {
  if (!real) {
    const foundation = new Date();
    foundation.setUTCFullYear(2017, 0, 1)
    foundation.setUTCHours(0, 0, 0, 0)
    this.setTime(foundation.getTime() + this.getTime())
    return this.format(format)
  }
}
Date.prototype.toWeiXinString = function (real = true) {
  let str;
  const now = new Date();
  if (!real) {
    const foundation = new Date();
    foundation.setUTCFullYear(2017, 0, 1)
    foundation.setUTCHours(0, 0, 0, 0)
    this.setTime(foundation.getTime() + this.getTime())
  }
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  const beforeYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
  const monday = new Date(today);
  monday.setDate(today.getDate() - (today.getDay() ? today.getDay() - 1 : 6));
  //注意：date初始化默认是按本地时间初始的，但打印默认却是按GMT时间打印的，也就是说打印出的不是本地现在的时间
  //LocaleString的打印也有点问题，"0点"会被打印为"上午12点"
  if (this.getTime() > today.getTime()) {
    str = "";
  } else if (this.getTime() > yesterday.getTime()) {
    str = "Yesterday";
  } /*else if(this.getTime() > beforeYesterday.getTime()) {
    str = "前天";
  }*/ else if (this.getTime() > monday.getTime()) {
    // const week = {"0":"周日","1":"周一","2":"周二","3":"周三","4":"周四","5":"周五","6":"周六"};
    const week = {"0": "Sun", "1": "Mon", "2": "Tue", "3": "Wednesday", "4": "Thu", "5": "Fri", "6": "Sat"};
    str = week[this.getDay() + ""];
  } else {
    const hour = ["am", "am", "pm", "pm"];
    // const hour = ["凌晨","早上","下午","晚上"];
    const h = this.getHours();
    /*if(h==12) str = "中午";
    // else */
    str = hour[parseInt(h / 6)];
    let middle = hour[parseInt(h / 6)];
    str = this.format("MM-dd ");
  }
  str += this.format("HH:mm");
  return str;
}

Date.prototype.toDiffString = function () {
  const now = new Date();
  const foundation = new Date();
  foundation.setUTCFullYear(2017, 0, 1)
  foundation.setUTCHours(0, 0, 0, 0)
  this.setTime(foundation.getTime() + this.getTime())
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
  let diff = now.getTime() - this.getTime();
  if (diff <= 60 * 1000) {
    return 'just now'
  } else if (diff < 3600 * 1000) {
    let mins = parseInt(diff / 60 / 1000)
    return mins + ' mins ago'
  } else if (this.getTime() > today.getTime()) {
    return this.format("HH:mm") + ' Today'
  }
  if (this.getTime() > yesterday.getTime()) {
    return this.format("HH:mm") + ' Yesterday'
  } else {
    return this.format("MM-dd-yyyy")
  }
}
/**
 * 比较时间大小
 * 如: A 时间是否在 B 时间之前
 * 例: new Date("2021-11-11").after(new Date("2020-11-11")) === true
 * @param {Date} date 另一个时间
 *  * @param {String} format  格式化后再进行比较
 * @return {Boolean}
 */
Date.prototype.before = function (date, format) {
  if (!format) return date.getTime() > this.getTime()
  let d1 = new Date(this.format(format)),
    d2 = new Date(date.format(format));
  return d2.getTime() > d1.getTime()
}

/**
 * 比较时间大小
 * 如: A 时间是否在 B 时间之后
 * 例: new Date("2021-11-11").after(new Date("2020-11-11")) === true
 * @param {Date} date 另一个时间
 * @param {String} format  格式化后再进行比较
 * @return {Boolean}
 */
Date.prototype.after = function (date, format) {
  return date.before(this)
}

/**
 * 比较两个时间是否相等
 * @param {Date} date 另一个时间
 * @param {String} format 格式化后再进行比较
 * @return {Boolean}
 */
Date.prototype.equal = function (date, format) {
  if (!format) return date.getTime() === this.getTime()
  let d1 = new Date(this.format(format)),
    d2 = new Date(date.format(format));
  return d2.getTime() === d1.getTime()
}

export function vibrate() {
  if ('vibrate' in window.navigator) {
    window.navigator.vibrate([10, 12, 10, 12, 10]); // 震动200停100再震动200，和qq的消息震动一样
  } else {
    console.log("浏览器不支持震动")
  }
}

export function fileExist(localPath) {
  return new ActiveXObject("Scripting.FileSystemObject").FileExists(localPath);
}

/**
 * 将时长转换为 01:20:10格式
 * @param time  单位秒 int
 * @return
 */
export function parseIntTimeSecond(time, shour = true, smin = true, ssec = true) {
  let second = time % 60
  let mins = Math.floor(time / 60 % 60)
  let hour = Math.floor(time / 60 / 60)
  let str = ''
  if (ssec)
    if (second >= 10) {
      str = second
    } else {
      str = '0' + second
    }
  if (smin)
    if (mins >= 10) {
      str = mins + ':' + str
    } else {
      str = '0' + mins + ':' + str
    }
  if (shour)
    if (hour >= 10) {
      str = hour + ':' + str
    } else {
      str = '0' + hour + ':' + str
    }
  if (str.startsWith(':'))
    str = str.slice(1, str.length - 1)
  return str
}

export function toDecimal(src) {
  var f = parseFloat(src);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(src * 100) / 100;
  return f;
}

export function filterArray(source, targetKey, targetVal) {
  if (isnull(source))
    return [];
  if (isnull(targetKey))
    return source;
  let result = [];
  source.forEach((item, index) => {
    if (!isnull(item) && item[targetKey] == targetVal) {
      item.index = index
      result.push(item)
    }
  })
  return result
}

export function getAnchorDistricts() {
  return [{
    'name': 'Global',
    'district': 1,
    'icn': 'nGlobal',
    'activeIcn': 'aGlobal',
  }, {
    'name': 'Western',
    'district': 2,
    'icn': 'nWestern',
    'activeIcn': 'aWestern',
  }, {
    'name': 'Latin',
    'district': 3,
    'icn': 'nLatin',
    'activeIcn': 'aLatin',
  }, {
    'name': 'Arabic',
    'district': 4,
    'icn': 'nArabic',
    'activeIcn': 'aArabic',
  }, {
    'name': 'Asian',
    'district': 5,
    'icn': 'nAsian',
    'activeIcn': 'aAsian',
  }, {
    'name': 'E-Europe',
    'district': 6,
    'icn': 'nEu',
    'activeIcn': 'aEu',
  },]

}

export function getAnchorSearchTags() {
  return [
    {
      tag: 2,
      lbl: 'Good Attitude'
    }, {
      tag: 3,
      lbl: 'Talkative'
    }, {
      tag: 5,
      lbl: 'Attractive Voice'
    }, {
      tag: 6,
      lbl: 'Nice Figure'
    }, {
      tag: 7,
      lbl: 'Young'
    }, {
      tag: 8,
      lbl: 'Mature'
    }, {
      tag: 4,
      lbl: 'Satisfying'
    }
  ]
}

export function getMediumLink(link) {
  if (isnull(link))
    return ''
  if (isWebP(link))
    return link;
  let suffix = '-medium'
  if (link.indexOf('.') == -1)
    return link + suffix
  let array = link.split('.')
  let tmpCorver = ''
  for (let i = 0; i < array.length; i++) {
    tmpCorver += array[i];
    if (i == array.length - 2) {
      tmpCorver += suffix + '.'
    } else if (i != array.length - 1)
      tmpCorver += '.'
  }
  // let res=await ImageUtils.checkUrl(tmpCorver,link)
  return tmpCorver
}

export function isWebP(link) {
  if (isnull(link))
    return false
  let url = link.split("?")[0]
  return url.indexOf('.webp') == url.length - 5
}

export async function getSearchHistory() {
  let history = []
  let key = global.withUserKey(global.key.SEARCH_HISTORY)
  let temp = await AppSDK.loadFromAppStorage(key)
  if (!isnull(temp)) {
    try {
      let tmpList = JSON.parse(temp)
      if (!isnull(tmpList) && Array.isArray(tmpList)) {
        history.push(...tmpList)
      }
    } catch (e) {
      console.log('getSearchHistoryE:' + e.message)
    }
  }
  return history
}

export function saveSearchHistory(history) {
  let historyData = ''
  if (isnull(history)) {
    historyData = JSON.stringify([])
  } else {
    historyData = JSON.stringify(history)
  }
  let key = global.withUserKey(global.key.SEARCH_HISTORY)
  localSave(key, historyData)
  AppSDK.notifySave2AppStorage(key, historyData)

}

export async function loadConversationAudioPlayedHistory(conversationId) {
  let history = []
  let temp = await AppSDK.loadFromAppStorage(conversationId)
  if (!isnull(temp)) {
    try {
      let tmpList = JSON.parse(temp)
      if (!isnull(tmpList) && Array.isArray(tmpList)) {
        history.push(...tmpList)
      }
    } catch (e) {
      console.log('loadConversationAudioPlayedList:' + e.message)
    }
  }
  return history
}

export function saveConversationAudioPlayedHistory(conversationId, history) {
  let historyData = ''
  if (isnull(history)) {
    historyData = []
  } else {
    historyData = history
  }
  localSave(conversationId, JSON.stringify(historyData))
  AppSDK.notifySave2AppStorage(conversationId, historyData)

}

export async function loadGreetHistory() {
  let history = []
  let key = global.withUserKey(global.key.GREET_HISTORY)
  let temp = await AppSDK.loadFromAppStorage(key)
  if (!isnull(temp)) {
    try {
      let tmpList = JSON.parse(temp)
      if (!isnull(tmpList) && Array.isArray(tmpList)) {
        history.push(...tmpList)
      }
    } catch (e) {
      console.log('loadGreetHistory:' + e.message)
    }
  }
  return history
}

export function saveGreetHistory(history) {
  let historyData = ''
  if (isnull(history)) {
    historyData = []
  } else {
    historyData = history
  }
  let key = global.withUserKey(global.key.GREET_HISTORY)
  localSave(key, JSON.stringify(historyData))
  AppSDK.notifySave2AppStorage(key, historyData)

}

export async function loadViewedCommonHotListHistory() {
  let history = []
  let key = global.withUserKey(global.key.VIEWED_MOMENT_HOT)
  let temp = await AppSDK.loadFromAppStorage(key)
  if (!isnull(temp)) {
    try {
      let tmpList = JSON.parse(temp)
      if (!isnull(tmpList) && Array.isArray(tmpList)) {
        history.push(...tmpList)
      }
    } catch (e) {
      console.log('getSearchHistoryE:' + e.message)
    }
  }
  return history
}

export function saveViewedCommonHotListHistory(history) {
  let historyData = ''
  if (isnull(history)) {
    historyData = []
  } else {
    historyData = history
  }
  let key = global.withUserKey(global.key.VIEWED_MOMENT_HOT)
  localSave(key, JSON.stringify(historyData))
  AppSDK.notifySave2AppStorage(key, historyData)

}

export function judgeLink(src) {
  if (isnull(src))
    return false;
  let linkReg = new RegExp("((http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)|(www.[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)", 'g')
  return !isnull(src.match(linkReg));

}

export function formatLink(src) {
  let protocolReg = new RegExp("(http[s]{0,1}|ftp)://")
  if (isnull(src.match(protocolReg)))
    src = "https://" + src
  return src;
}

export function debounce(fn, delay = 600) {
  let timer = null
  return function () {
    let content = this
    let args = arguments
    if (timer)
      clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(content, args)
    })
  }
}

export function gs(appInfo) {
  let t = appInfo.channel + appInfo.s + appInfo.deviceId.toUpperCase();
  return md5(t).toUpperCase();
}

export function gsWithAcc(acc, pwd,appInfo) {
  let t =  appInfo.channel + appInfo.s  + acc + pwd;
  return md5(t).toUpperCase();
}

function filterIllegalGame(gameList) {
  if (isnull(gameList))
    return gameList;
  let targetGames = Array()
  for (let i = 0; i < gameList.length; i++) {
    if (gameList[i].enable)
      targetGames.push(gameList[i])
  }
  return targetGames;

}

export function showGameDialog(games, from) {
  let targets = filterIllegalGame(games)
  global.application.$EventBus.$emit(EventBusConstant.EVENT_SHOW_GAME_DIALOG, targets, from)
}

export function showLiveRoomToolDialog(pureOff, rechargeCallback = null, clearCallback = null,) {
  global.application.$EventBus.$emit(EventBusConstant.EVENT_SHOW_ROOM_TOOL_DIALOG, 1, pureOff, rechargeCallback, clearCallback)
}

export function showMBRoomToolDialog(selfBoss = false, micOff = false, cameraOff = false, rechargeCallback, micCallback = null, cameraCallback = null, flipCallback = null) {
  global.application.$EventBus.$emit(EventBusConstant.EVENT_SHOW_ROOM_TOOL_DIALOG, 2, selfBoss, micOff, cameraOff, rechargeCallback, micCallback, cameraCallback, flipCallback)
}

export function httpWithRaw(url, method, data, loading, successCallback, failCallback = false, async = false) {
  $.ajax({
    url: url,
    type: method,
    async: async,
    contentType: 'application/json',
    data: JSON.stringify(data),
    success: function (result) {
      successCallback(result)
    },
    beforeSend: function () {
      // if (loading)
      //   showLoading()
    },
    complete: function () {
      // if (loading)
      //   dismissLoading()
    }, error: function (error) {
      failCallback && failCallback(error)
    }
  })
}

export function showAlertDialog(type, actions, callbacks = null, extra = {}, hideFromOut = true, msg = null, title = null,titleColor=null,contentColor=null,firstBgColor = null, secondBgColor = null, firstTextColor = null, secondTextColor = null) {
  global.application.$EventBus.$emit(global.SHOW_ALERT_ACTION_DIALOG, type, actions, callbacks, extra, hideFromOut, msg, title,titleColor,contentColor,firstBgColor,secondBgColor,firstTextColor,secondTextColor)

}

export function hideAlertDialog(type, actions, callbacks = null, extra = {}, hideFromOut = true, msg = null, title = null) {
  global.application.$EventBus.$emit(global.HIDE_ALERT_ACTION_DIALOG)

}

export function showLogRegDialog(from='') {
  global.application.$EventBus.$emit(EventBusConstant.EVENT_SHOW_LOG_REG,from)

}

export function showHangUp(code,data) {
  global.application.$EventBus.$emit(EventBusConstant.EVENT_HUNG_UP,code,data)
}

export function renew(successCallback=null,failCallback=null) {
  doLoginAsVisitor((data, page) => {
    IMManager.tryInitAVIMClient(page)
    localSave(global.key.RELOAD_ROOM_LIST, true)
    localSave(global.key.RENEW, true)
    successCallback && successCallback(data, page)
  }, function (code, msg, page) {
    Toast.error(TipsUtils.getErrorTips(code), page)
    failCallback && failCallback(code, msg, page)
  }, global.application)

}




// WEBPACK FOOTER //
// ./src/utils/tools.js